export default __webpack_public_path__ + "static/media/button-share-news.24ead096.svg";